/**
 * Module store for the user informations.
 * Storing here avoid data to be overwritten on Store reset() call
 */
const state = {
  userName: undefined,
  isLogin: false,
};

const mutations = {
  setUserName(state, userName) {
    state.userName = userName;
  },
  setIsLogin(state, isLogin) {
    state.isLogin = isLogin;
  },
};

export default {
  state,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js